/**
 * A revision label already opening with some form of "Rev": "Rev 1",
 * "REV. 2", "rev  3". Not "R3" or "revision" — different conventions, and
 * not yet a confirmed shape to guard against.
 *
 * Shared across two domains that each spell the prefix differently: the
 * Library's revision-chain formatters use "Rev " (space — recordService.ts's
 * `revisionLabelText`), the chat/citation source formatters use "Rev. "
 * (period — `revisionAttributionText` below). Both need the same
 * idempotency check so neither re-decorates a value that already carries a
 * prefix — reading it from the same extractor metadata that produced the
 * original doubling bug (frontend#2542, frontend#2596).
 */
const ALREADY_PREFIXED = /^rev\.?\s/i;

export const hasRevisionPrefix = (label: string): boolean =>
  ALREADY_PREFIXED.test(label);

/**
 * "Rev. 1" from a raw revision — the chat/citation surfaces' convention
 * (formatCitation, DocumentSourceTier, InChatDocumentViewer), idempotent
 * against a value that already carries some form of "Rev" prefix rather
 * than doubling it to "Rev. Rev 1" (frontend#2596).
 */
export const revisionAttributionText = (revision: string): string =>
  hasRevisionPrefix(revision) ? revision : `Rev. ${revision}`;
